import React, { forwardRef } from 'react';
import classNames from '../utility/classNames';

const LeftColumn = forwardRef(
  (
    { fullWidth, sectionTitle = '', keyMetric, summary, classes, children, id },
    ref
  ) => {
    return (
      <section
        ref={ref}
        id={id}
        aria-labelledby={sectionTitle}
        className={classNames(
          'col-span-3 bg-white shadow-md rounded',
          !keyMetric && !summary
            ? 'sm:pt-[26px] sm:pb-[26px] sm:pl-[20px] sm:pr-[40px]'
            : '',
          fullWidth ? 'lg:col-span-3' : 'lg:col-span-2',
          classes || 'my-3 mb-6 py-4 px-6'
        )}
      >
        <h2 className="sr-only" id={sectionTitle}>
          {sectionTitle}
        </h2>
        {children}
      </section>
    );
  }
);

export default LeftColumn;
